import { render } from "./EmojiPickerSearch.vue?vue&type=template&id=b1e399a8"
import script from "./EmojiPickerSearch.vue?vue&type=script&lang=js"
export * from "./EmojiPickerSearch.vue?vue&type=script&lang=js"

import "./EmojiPickerSearch.vue?vue&type=style&index=0&id=b1e399a8&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__